import { ClockIcon } from "@heroicons/react/solid";
import CalendarScheduleSlotModel from "../../../models/CalendarScheduleSlotModel";
import CompactSlotTitle from "../CompactSlotTitle";
import SlotTime from "../SlotTime";
import { Popover } from "@headlessui/react";

export default function CompactUpcomingSlot({
  slot,
  onClick,
  setOpen,
}: {
  slot: CalendarScheduleSlotModel;
  onClick: (slot: CalendarScheduleSlotModel) => void;
  setOpen?: () => void;
}) {
  return (
    <button
      role="button"
      className="w-full px-1  h-full  py-0.5 rounded-md bg-white"
      onClick={!!setOpen ? setOpen : () => {}}
    >
      <div
        role="button"
        onClick={() => onClick(slot)}
        className="hover:bg-brandblue-700   shadow-md  w-full h-full overflow-y-auto rounded-md bg-brandblue-600 px-2 py-1"
      >
        <p className="text-white text-xs leading-5 font-normal flex items-center justify-between">
          <CompactSlotTitle slot={slot} />
          <ClockIcon className="h-5 w-5" aria-hidden="true" />
        </p>
      </div>
    </button>
  );
}
